import type { LDContext, LDSingleKindContext } from '../types/types';

/**
 * Check if a context is a single kind context.
 * @param context - The context to check.
 * @returns true if the context is a single kind context.
 */
export function isSingleKind(context: LDContext): context is LDSingleKindContext {
  if ('kind' in context) {
    return context.kind !== 'multi';
  }
  return true;
}
